// removed by extract-text-webpack-plugin
module.exports = {"panel":"styles__panel___1Zq3m"};


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/panel/styles.css
// module id = z/Jy
// module chunks = 2